import type { HttpCore } from '../http';
import type { ChangePasswordRequest, OkResponse, UpdateMeRequest, User } from '../types';

/** `/api/v1/me` — the signed-in customer's own profile. */
export function createMeApi(http: HttpCore) {
  return {
    get: () => http.get<User>('/me'),
    update: (body: UpdateMeRequest) => http.patch<User>('/me', body),
    changePassword: (body: ChangePasswordRequest) => http.post<OkResponse>('/me/password', body),
    /** Deletes the account (and, server-side, its devices and data). */
    remove: () => http.del<OkResponse>('/me'),
  };
}

export type MeApi = ReturnType<typeof createMeApi>;
